module.exports = __webpack_public_path__ + "6541ecfc40a8af1529b4154d75381a5d.svg";